import Marquee from 'react-fast-marquee'

import classnames from 'classnames'

import type { IconTypes } from '../Icon/Icon'
import { Icon } from '../Icon/Icon'
import Link from '../Link/Link'

import styles from './LogoMarquee.module.css'

interface LogoProps {
  name: IconTypes
  url?: string
  altText: string
  squash: boolean
}

export interface LogoMarqueeProps {
  data: LogoProps[]
  testID?: string
}

export default function LogoMarquee({ data, testID }: LogoMarqueeProps) {
  const renderLogo = (logo: LogoProps, idx: number, id: string) => {
    return (
      <div
        className={classnames(styles.container, {
          [styles.containerWithSquash]: logo.squash,
        })}
        key={idx}
      >
        {logo.url ? (
          <Link
            key={`${id}-link-${idx}`}
            href={logo.url}
            title={logo.altText}
            testID={testID && `${testID}-link`}
          >
            <Icon
              type={logo.name}
              testID={testID && `${testID}-icon`}
              responsive={true}
            />
          </Link>
        ) : (
          <Icon
            key={`${id}-${idx}`}
            type={logo.name}
            testID={testID && `${testID}-icon`}
            responsive={true}
          />
        )}
      </div>
    )
  }
  return (
    <div className={styles.base}>
      <Marquee
        play={true}
        pauseOnHover={false}
        speed={30}
        gradientWidth={0}
        className="logoMarquee"
      >
        {data.map((logo, idx) => renderLogo(logo, idx, 'marquee'))}
      </Marquee>
    </div>
  )
}
